const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}?Z$/;

const reviver = (key, value) => {
  if (typeof value === 'string' && dateFormat.test(value)) {
    return new Date(value);
  }

  return value;
};

export const deserialize = <T>(json: string): T => {
  return JSON.parse(json, reviver) as T;
};

export const serialize = <T>(instance: T): string => {
  return JSON.stringify(instance);
};
